import React, { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "kzool-theme";

const ThemeContext = createContext(null);

// Resolve the initial theme once, before first paint, from localStorage or the OS preference.
function getInitialTheme() {
  if (typeof window === "undefined") return "light";
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch (e) {
    // localStorage may be unavailable (private mode / disabled) — fall through to OS pref.
  }
  if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
    return "dark";
  }
  return "light";
}

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(getInitialTheme);

  // Persist the theme whenever it changes. Applying the `.dark` class onto <html>
  // is delegated to ThemeRouteScope so dark mode stays scoped to /dashboard.
  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
      // Persistence is best-effort; ignore storage failures.
    }
  }, [theme]);

  const toggleTheme = () => setTheme((prev) => (prev === "dark" ? "light" : "dark"));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return ctx;
};
